export const headCells = [
    {
        id: 'nomeEmpresa',
        numeric: false,
        disablePadding: true,
        label: 'Empresa'
      },
      {
        id: 'email',
        numeric: true,
        disablePadding: false,
        label: 'E-mail'
      },
      {
        id: 'telefone',
        numeric: true,
        disablePadding: false,
        label: 'Telefone'
      },
      {
        id: 'responsavel',
        numeric: false,
        disablePadding: false,
        label: 'Responsável'
      },
      {
        id: 'origem',
        numeric: true,
        disablePadding: false,
        label: 'Origem do Lead'
      },
      {
        id: 'data_cadastro',
        numeric: true,
        disablePadding: false,
        label: 'Data de Cadastro'
      },
      {
        id: 'cnpj',
        numeric: true,
        disablePadding: false,
        label: 'CNPJ'
      }
    ]